export default __webpack_public_path__ + "static/loadingspinner-51233b3b73ecdeaa686da2a6c8040203.gif";